import { FC } from "react";

export const InactiveColumn: FC = () => {
    return (
        <svg
            viewBox="0 0 570 94"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            preserveAspectRatio="none"
        >
            <path
                d="M0 26.5208C0 25.6923 0.671573 25.0208 1.5 25.0208H78.2143C79.0427 25.0208 79.7143 25.6923 79.7143 26.5208V92.4999C79.7143 93.3283 79.0427 93.9999 78.2143 93.9999H1.5C0.671571 93.9999 0 93.3283 0 92.4999V26.5208Z"
                fill="#B5B7C0"
                fillOpacity="0.1"
            />
            <path
                d="M81.7139 24.55C81.7139 23.7216 82.3854 23.05 83.2139 23.05H159.928C160.757 23.05 161.428 23.7216 161.428 24.55V92.5C161.428 93.3285 160.757 94 159.928 94H83.2139C82.3854 94 81.7139 93.3285 81.7139 92.5V24.55Z"
                fill="#B5B7C0"
                fillOpacity="0.1"
            />
            <path
                d="M163.429 28.8501C163.429 28.0217 164.1 27.3501 164.929 27.3501H241.643C242.471 27.3501 243.143 28.0217 243.143 28.8501V92.5001C243.143 93.3285 242.471 94.0001 241.643 94.0001H164.929C164.1 94.0001 163.429 93.3285 163.429 92.5001V28.8501Z"
                fill="#B5B7C0"
                fillOpacity="0.1"
            />
            <path
                d="M245.143 25.625C245.143 24.7966 245.814 24.125 246.643 24.125H323.357C324.185 24.125 324.857 24.7966 324.857 25.625V92.5C324.857 93.3284 324.185 94 323.357 94H246.643C245.814 94 245.143 93.3284 245.143 92.5V25.625Z"
                fill="#B5B7C0"
                fillOpacity="0.1"
            />
            <path
                d="M326.857 17.5625C326.857 16.7341 327.529 16.0625 328.357 16.0625H405.072C405.9 16.0625 406.572 16.7341 406.572 17.5625V92.5C406.572 93.3284 405.9 94 405.072 94H328.357C327.529 94 326.857 93.3284 326.857 92.5V17.5625Z"
                fill="#B5B7C0"
                fillOpacity="0.1"
            />
            <path
                d="M408.571 22.3999C408.571 21.5715 409.243 20.8999 410.071 20.8999H486.786C487.614 20.8999 488.286 21.5715 488.286 22.3999V92.4999C488.286 93.3283 487.614 93.9999 486.786 93.9999H410.071C409.243 93.9999 408.571 93.3283 408.571 92.4999V22.3999Z"
                fill="#B5B7C0"
                fillOpacity="0.1"
            />
            <path
                d="M490.286 26.6999C490.286 25.8715 490.958 25.2 491.786 25.2H568.5C569.329 25.2 570 25.8715 570 26.7V92.5C570 93.3284 569.329 94 568.5 94H491.786C490.958 94 490.286 93.3284 490.286 92.5V26.6999Z"
                fill="#B5B7C0"
                fillOpacity="0.1"
            />
        </svg>
    );
};
